export default function findPromotionForVehicle(promotion, vehicle) {
  if (!promotion) {
    return null;
  }

  if (promotion.enable_all_families) {
    return promotion;
  }

  if (promotion.enable_all_brands) {
    return promotion;
  }

  const supportedByStockId = promotion.enabled_vehicles.find(
    (enabledVehicle) =>
      parseInt(enabledVehicle.stock_id) === parseInt(vehicle.id)
  );

  if (supportedByStockId) {
    return promotion;
  }

  return promotion.enable_brands?.includes(vehicle.brand_id) ? promotion : null;
}
